// extracted by mini-css-extract-plugin
export default {"content":"Logined_content__7Oa65"};